export default __webpack_public_path__ + "static/media/icon-question-mark.302d1974.svg";